import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { App } from './App';
import { msalInstance } from './auth/msalInstance';
import { bootstrapMsal } from './auth/msalBootstrap';
import './index.css';

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

function renderApp() {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
}

function renderBootError(message: string) {
  root.render(
    <div style={{ padding: '2rem', fontFamily: 'sans-serif', color: '#6b21a8' }}>
      <h1>Unable to start sign-in</h1>
      <p>{message}</p>
      <button type="button" onClick={() => window.location.reload()}>
        Retry
      </button>
    </div>
  );
}

async function bootstrap() {
  try {
    await bootstrapMsal();
    renderApp();
  } catch (error) {
    console.error('MSAL bootstrap failed:', error);
    const message = error instanceof Error ? error.message : 'Authentication initialization failed.';
    renderBootError(message);
  }
}

bootstrap();
